import { render, staticRenderFns } from "./CompraDividaDetalhe.vue?vue&type=template&id=425cf162&"
import script from "./CompraDividaDetalhe.vue?vue&type=script&lang=js&"
export * from "./CompraDividaDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports